import React, { Fragment, useEffect, useState } from "react";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TablePagination,
  Checkbox,
  OutlinedInput,
  InputAdornment,
  IconButton,
  TableContainer,
  Box,
  FormControl,
  Paper,
} from "@mui/material";
import { getActivityAuditList } from "../../services/auditService";
import { useSelector } from "react-redux";
import { dateParser } from "../../helper";
import CardSkeleton from "../common/Skeletons/CardSkeleton/CardSkeleton";

const RecentActivity = () => {
  let cellColumns = ["Activity", "Description", "Modified on"];
  const [recentActivityList, setRecentActivityList] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(true);
  const currentBusinessUnit = useSelector(
    (state: any) => state.auth.currentBusinessUnit
  );
  const [auditCount, setAuditCount] = useState(0);
  const [controller, setController] = useState({
    page: 0,
    limit: 10,
  });
  const handlePageChange = (event: any, newPage: number) => {
    setController({
      ...controller,
      page: newPage,
    });
  };

  const handleChangeRowsPerPage = (event: any) => {
    setController({
      ...controller,
      limit: parseInt(event.target.value, 10),
      page: 0,
    });
  };
  useEffect(() => {
    const reqObj = {
      controller: controller,
    };
    getActivityAuditList(reqObj)
      .then((res: any) => {
        let recentActivityList = res.data.activityAudits;
        let auditCount = res.data.total_count;
        setAuditCount(auditCount);
        setRecentActivityList(recentActivityList);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [currentBusinessUnit, controller]);
  return (
    <Fragment>
      <div className="flex flex-col p-4">
        {isLoading ? (
          <Fragment>
            <div className="flex flex-col gap-7">
              <CardSkeleton type="text" count={8} />
              <CardSkeleton type="text" count={8} />
              <CardSkeleton type="text" count={8} />
            </div>
          </Fragment>
        ) : (
          <>
            <div className="text-black mb-2 text-sm font-bold font-['Proxima Nova']">
              Recent activity
            </div>
            {recentActivityList?.length ? (
              <Table>
                <TableHead className="bg-neutral-50">
                  <TableRow>
                    {cellColumns.map((column) => (
                      <TableCell key={column}>{column}</TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody className="bg-white">
                  {recentActivityList.map((eachAudit: any) => (
                    <TableRow key={eachAudit.id}>
                      <TableCell>{eachAudit.activity}</TableCell>
                      <TableCell>{eachAudit.description}</TableCell>
                      <TableCell>{dateParser(eachAudit.created)}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            ) : (
              <div className="px-40 w-full h-24 bg-slate-200 justify-center items-center inline-flex">
                <div className="text-slate-500 text-sm font-medium font-['Proxima Nova']">
                  Recent activities will be displayed here
                </div>
              </div>
            )}
          </>
        )}
      </div>
      {auditCount > 10 && (
        <TablePagination
          component="div"
          className="pw-pagination"
          onPageChange={handlePageChange}
          page={controller.page}
          count={auditCount}
          rowsPerPage={controller.limit}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      )}
    </Fragment>
  );
};

export default RecentActivity;
